import { Collapse } from '@nexelem/deprecated-theme';
import { ProLightCopy } from '@nexelem/icons/ProLightCopy';
import { ProLightDownLeftAndUpRightToCenter } from '@nexelem/icons/ProLightDownLeftAndUpRightToCenter';
import { ProLightUpRightAndDownLeftFromCenter } from '@nexelem/icons/ProLightUpRightAndDownLeftFromCenter';
import { IconButton } from '@nexelem/components';
import { useCustomToast } from '@nexelem/snackbar';
import { cn } from '@nexelem/utils';
import { ReactNode, useState } from 'react';
import { SingleDetailLabel } from './SingleDetailLabel';
import { useCustomTranslation } from '../../../hooks';

type SingleDetailExpandableProps = {
  title: ReactNode;
  content: string;
};

export const SingleDetailExpandable = ({ title, content }: SingleDetailExpandableProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { tWrapper } = useCustomTranslation('components.singleDetailEditable');

  // TODO - does not working without https environment, wait for BE team to implement it => NEX-1305
  const displayToast = useCustomToast();
  const handleCopy = async () => {
    await navigator.clipboard.writeText(content);
    displayToast({
      toastType: 'info',
      message: tWrapper('toast'),
    });
  };

  const toggleIsExpanded = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const isClipboard = !!navigator.clipboard;

  return (
    <div className="relative flex flex-col gap-1 border border-border-secondary bg-surface-container-lighter px-2 py-4">
      <SingleDetailLabel>{title}</SingleDetailLabel>
      <div className="absolute top-2 right-2 flex gap-1">
        {isClipboard && <IconButton Icon={ProLightCopy} size="small" onClick={handleCopy} />}
        <IconButton
          Icon={isExpanded ? ProLightDownLeftAndUpRightToCenter : ProLightUpRightAndDownLeftFromCenter}
          size="small"
          onClick={toggleIsExpanded}
        />
      </div>
      <Collapse collapsedSize={30} in={isExpanded}>
        <p
          className={cn('px-2 py-1 text-s18', !isExpanded ? 'truncate text-nowrap' : 'break-words whitespace-pre-wrap')}
        >
          {content}
        </p>
      </Collapse>
    </div>
  );
};
